import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { Waves_ModuleContextService } from './Waves.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class Waves_pick_slip_by_wave_id_consolidated_report_ComponentContextService {
  private readonly moduleContext: Waves_ModuleContextService;

  constructor(moduleContext: Waves_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'pick_slip_by_wave_id_consolidated_report',
      type: ComponentType.report
    }
  }
}